import Vue from 'vue'
/* eslint-disable no-console*/

function Campaign(data) {
    this.title = getTitle(data.Metadata, data.Title),
    this.fastActions = checkFastActions(data),
    // this.time = countUserFlow(data.UserFlow) +" "+ Vue.prototype.$locale.cards.minutes,
    this.time = countUserFlow(data.UserFlow)
    this.coins = data.Payout,
    this.iconUrl = data.Icon,
    this.id = data.ID,
    this.language = data.Language,
    this.creatives = data.Creatives,
    this.adv_id = data.TrackingUrl,
    this.model = data.Model,
    this.package = data.Package,
    this.metadata = data.Metadata,
    // this.description = data.Description
    this.description = getDescription(data.Metadata),
    this.advertorial = getAdvertorial(data.Creatives),
    this.open = false,
    this.type = "offer"
}

function Poll(data) {
  this.id = data.survey_id,
  this.coins = data.reward_value / 10,
  this.sponsor = data.survey_class,
  this.currency = data.reward_name,
  this.url = data.survey_link,
  // this.loi = data.survey_loi +" "+ Vue.prototype.$locale.cards.minutes
  this.time = data.survey_loi
  this.type = "survey"
}

function checkFastActions(element) {
    var flows = "";
    if (element.UserFlow == "") {
      // flows = "Install|Open";
      flows = Vue.prototype.$locale.cards.install+"|"+Vue.prototype.$locale.cards.open;
      // flows = "Installa|Apri";
    } else flows = element.UserFlow;
    return flows;
}

function countUserFlow(actions) {
    var actionsList = [];
    actionsList = actions.split("|");
    var time = 0;
    actionsList.forEach(el => {
        if (el.includes("Install")) time += 1;
        else if (el.includes("Open")) time += 0;
        else if (el.includes("level")) time += 6;
        else time += 2;
    });
    if (actionsList[0] == "") time = 2;
        return time;
}

function getDescription(metadata){
  var html = null;
  metadata.forEach(meta => {
    if(meta.Language === "it"){ //hardcoded for italian
      // console.log(meta.Html)
      html = meta.Html;
    }
  })
  return html;
  // metadata.forEach(meta => {
  //   if(meta.Language === "*"){
  //     return meta.Html;
  //   }
  // })
  // return null;

  // if (metadata[1] && metadata[1].Html)  //hardcoded. need to handle different languages later.
  //   return metadata[1].Html;
  // else
  //   return null;
}

function getTitle(metadata, generalTitle){
  var title = null;
  metadata.forEach(meta => {
    if(meta.Language === "it"){ //hardcoded for italian
      console.log(meta.Title)
      title = meta.Title;
    }
  })
  if(!title)
    title = generalTitle
  return title;
}

function getAdvertorial(creatives){
  for (let index = 0; index < creatives.length; index++)
  {
      if (creatives[index].Type == "ADVERTORIAL_COVER")
          return creatives[index].Url;
  }

  // if (creatives != null & creatives.length > 0)
  //     return creatives[0].Url;
  return null;
}

  export{
    Campaign,
    Poll
}